import script from "./ProjectRecentlyDeletedVideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectRecentlyDeletedVideo.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectRecentlyDeletedVideo.vue?vue&type=style&index=0&id=07b90863&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b90863"]])

export default __exports__